import { Icon } from '@atom/mui';
import { FolderIcon, type IconComponent } from '@atom/mui/icons';

import classes from './analyticsListEmpty.module.css';

interface Props {
  message?: string;
  icon?: IconComponent;
}

const AnalyticsListEmpty = ({
  message = 'This folder is empty',
  icon = FolderIcon,
}: Props) => (
  <div className={classes.emptyListContainer}>
    <Icon
      style={{ fontSize: '3.5rem' }}
      className={classes.emptyListIcon}
      icon={icon}
    />
    <span className={classes.emptyListText}>{message}</span>
  </div>
);

export default AnalyticsListEmpty;
